<template>
	<v-layout row wrap align-center class="commerce-info">
		<v-flex xs3>
			<div class="commerce-info-image">
				<img
					:src="commerce.logo"
					:alt="`logo comercio ${commerce.name}`"
					class="commerce-info-logo"
				/>
			</div>
		</v-flex>
		<v-flex xs7>
			<v-layout row wrap>
				<v-flex xs12>
					<h2 class="commerce-info-name">{{ commerce.name }}</h2>
				</v-flex>
				<v-flex xs12>
					<span class="commerce-info-distance">{{ commerce.distance }} de distancia</span>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs2>
			<v-btn
				class="ma-0"
				depressed
				flat
				icon
			>
				<img
					src="/static/images-new/icons/icon-config-location.svg"
					alt="cambiar de comercio"
					height="26"
				/>
			</v-btn>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: 'commerce-info',
		props: {
			commerce: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.commerce-info {
		line-height: normal;
		margin-top: 18px;

		@media (min-width: 936px) {
			margin-top: 0px;
		}

		&-image {
			border-radius: 100%;
			box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);
			height: 52px;
			overflow: hidden;
			padding-top: 5px;
			width: 52px;
		}

		&-logo {
			height: 42px;
		}

		&-name {
			color: color(newwarning);
			font-size: size(medium16);
			font-weight: weight(black);
		}

		&-distance {
			color: color(newprimary);
			font-size: size(caption);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/commerce-info.vue